// import { AddCoinbaseAccount } from '../add-coinbase-account'
import { AddVezgoAccount } from '../add-vezgo-account'

export function AddCryptoAccount() {
    return (
        <>
            <div>
                <div className='flex flex-col justify-between w-full gap-12 lg:flex-row'>
                    {/* <AddCoinbaseAccount /> */}
                    <AddVezgoAccount />
                </div>
            </div>
        </>
    )
}
